import React from 'react'
import './Logout.css'
const Logout = () => {
  return (
    <div className='logout-container'>
        <div className="logout-content">
            <h1>You are successfully logged out !</h1>
            <p>Thank you for using New Store. Have a great day.</p>
        </div>


    </div>
  )
}

export default Logout